<template>
  <MongoDataTable
    ref="table"
    :offline="true"
    :title="title"
    :autoSchema="schema === undefined ? true : false"
    :schema="schema"
    :items="items"
    :syncUserState="false"
    :insertable="false"
    :editable="true"
    :readonly="false"
    :copyable="false"
    :deletable="false"
    :selectable="false"
    :refreshable="false"
    :filterable="true"
    :columnSelectable="true"
    :sortable="true"
    :countable="true"
    :hideHeaders="false"
    :hideFooters="false"
    :rowClass="() => {}"
    containerClass="elevation-0"
    toolbarClass="pt-0"
    @click:row="props => {}"
    :onInsert="onInsert"
    :onEdit="onEdit"
    :onDelete="onDelete"
  >
  </MongoDataTable>
</template>

<script>
import MongoDataTable from '../../components/mongo-datatable/MongoDataTable'

export default {
  props: {
    loading: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: null },
    items: { type: Array, required: true },
    schema: { type: Object, required: false },
    onInsert: { type: Function, required: false, default: null },
    onEdit: { type: Function, required: false, default: null },
    onDelete: { type: Function, required: false, default: null }
  },
  components: {
    MongoDataTable
  },
  methods: {}
}
</script>
